const EnvVars = {
  AWS_REGION: process.env.REACT_APP_AWS_REGION || "",
  AWS_COGNITO_CLIENT_ID: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID || "",
  AWS_COGNITO_ENDPOINT: 
    process.env.REACT_APP_AWS_COGNITO_ENDPOINT || 
    "https://cognito-idp.eu-west-1.amazonaws.com/",
  AWS_COGNITO_USER_POOL_ID:
    process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID || "",
  AWS_COGNITO_AUTHENTICATION_FLOW:
    process.env.REACT_APP_AWS_COGNITO_AUTHENTICATION_FLOW ||
    "USER_SRP_AUTH",
  MAIN_PLATFORM_API_GATEWAY_URL:
    process.env.REACT_APP_MAIN_PLATFORM_API_GATEWAY_URL || "",
  // Public key identifying web apps to the main platform's API Gateway: not a
  // secret, the Cognito token identifies the user
  MAIN_PLATFORM_FRONTEND_API_KEY:
    process.env.REACT_APP_MAIN_PLATFORM_FRONTEND_API_KEY ||
    "droople-public-frontend-key",
  MAIN_PLATFORM_URL: process.env.REACT_APP_MAIN_PLATFORM_URL || "",
  EVERCLEAN_API_GATEWAY_URL:
    process.env.REACT_APP_EVERCLEAN_API_GATEWAY_URL || "",
  PLATFORM_VERSION: process.env.REACT_APP_PLATFORM_VERSION || "",
};
export default EnvVars;
